// src/components/Dashboard/DesktopDashboard.tsx

import React, { useContext } from "react";
import Flex from "../../../../../../components/structure/Flex";
import { ProfileContext } from "../../../../../../contexts/profile";
import UpcomingBooking from "./components/UpcomingBooking";
import UserStats from "./components/UserStats";

const DesktopDashboard: React.FC = () => {
  const { profile } = useContext(ProfileContext);

  return (
    <section className="p-4 pb-24 mt-8 bg-gray-100 rounded-lg sm:pb-4">
      <header className="flex items-center justify-between">
        <Flex col>
          <h1 className="text-3xl font-black capitalize">
            Welcome,
            <span className="text-orange-500">{` ${
              profile.first_name || ""
            }!`}</span>
          </h1>
        </Flex>
      </header>

      <div className="my-8 border-b" />

      <UserStats />
      <UpcomingBooking />
    </section>
  );
};

export default React.memo(DesktopDashboard);
